var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToolAdmin',{attrs:{"user":_vm.user,"tool-id":"CustomerServiceAgentAssist","tool-name":"Agent Assist","tool-icon":"mdi-robot"}})
}
var staticRenderFns = []

export { render, staticRenderFns }